<template>
  <div class="faq" v-if="label">
    <section class="hero">
      <div class="hero-body">
        <div class="container">
          <h1 class="title">{{label.titles.faq}}</h1>
          <h2 class="subtitle">{{label.titles.generalQuestions}}</h2>
        </div>
      </div>
    </section>

    <div class="container">
      <article v-for="question of availableQuestions" :key="question" class="message box">
        <div class="message-header" @click="toggleMessage">
          <awesome-icon icon="chevron-right" class="arrow"/>
          <p>{{label[question].title}}</p>
        </div>
        <div class="is-collapsible">
          <div class="message-body"
            v-html="label[question].contentHTML">
          </div>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      questions: ["createAccount","whichEmail","changeEmail", "changePassword","accessPoint","myConso","accessRequest","free", "direction", "gas", "multipleContracts","moveOut","EAN","meter","myDGO","delegation","timeframe","readingVsCons","events","dataUsage","deleteAccount","colorblind"]
    }
  },
  mounted() {
    this.resetActive()
  },
  computed: {
    ...mapState({ label: state => state.labels.faq }),
    availableQuestions() {
      if(!this.label)
        return []
      return this.questions.filter(question => this.label[question])
    }
  },
  methods: {
    ...mapActions("labels", ["getLabel"]),
    toggleMessage(event) {
      // Get message to collapse
      const arrow = event.target.querySelector('.arrow');
      const message = event.target.nextElementSibling;

      // Collapse all messages
      this.resetActive(message);

      // toggle active classe and expand or collapse
      message.classList.toggle('is-active');
      message.style.height = message.classList.contains('is-active') ? message.scrollHeight + 'px' : '0px';
      arrow.classList.toggle('down')
    },
    resetActive(currentNode = null) {
      // Deactivate all messages => to be only one appears (accordion)
      const collapsible = document.getElementsByClassName('is-collapsible');
      Array.from(collapsible).forEach(message => {
        if (message !== currentNode) {
          message.classList.remove('is-active');
          message.style.height = '0px';
          message.parentNode.querySelector('.arrow').classList.remove('down');
        }
      })
    }
  },
  async created() {
    await this.getLabel({ view: 'faq' })
  }
}
</script>

<style lang="scss" scoped>
.box {
  padding: 0;
}
.message-header {
  justify-content: flex-start;
  cursor: pointer;
  transition: all .2s cubic-bezier();

  &:hover {
    transition: all .2s ease;
    background-color: #8796c9;
    color: #fff;
  }

  & > * {
    pointer-events: none;
  }
}

.is-collapsible {
  overflow-y: hidden;
  transition: height .2s ease;
  height: 0px;
  margin-bottom: 1rem;
}

.is-collapsible.is-active {
  transition: height .2s ease;
}

.arrow {
  margin-right: 1rem;
  transition: transform .2s ease;
}
.arrow.down {
  transition: transform .2s ease;
  transform: rotate(90deg);
}

::v-deep ul {
  padding-left: 2rem;
  list-style-type: disc;
}
</style>